import { getEnumeration } from 'enumeration'
import timeutils from 'utils/wt-time-utils'
import {
  auditTypes,
  auditStatus,
  rewardTypes,
  withdrawStatus,
  flashBorrowStatus,
  manualAuditStatus,
  businessTypes,
  showRewardStatus,
  rewardedStatus,
  integralAuditStatus,
  starSalesmanAuditTypes,
  starSalesmanAuditStatus,
  payOptions,
  payStaus
} from 'json/new-to-old-audit'
import { newOrderStatus, channelOptions } from 'json/goods-order-options'
import { goodsTypes } from 'json/deposit-settlement'
import { cashCount, strReplace } from '@/utils/formUtils'
import datas from './index'
export default {
  bringNewRewardList (data) {
    let list = data.list || data
    if (data instanceof Object) {
      data.allCustomerOfMoney = data.allCustomerMoney ? cashCount(data.allCustomerMoney, true) : data.allCustomerMoney
      data.newCustomerOfMoney = data.newCustomerMoney ? cashCount(data.newCustomerMoney, true) : data.newCustomerMoney
      data.oldCustomerOfMoney = data.oldCustomerMoney ? cashCount(data.oldCustomerMoney, true) : data.oldCustomerMoney
    }
    list.forEach(item => {
      let extendInformation = (item.genericReward && item.genericReward.extendInformation) || {}
      let reward = (item.genericReward && item.genericReward.reward) || {}
      let customerBringNew = extendInformation.customerBringNew || {}
      let refundInfo = (item.genericReward && item.genericReward.refundInfo) || {}
      item.extendInformation = extendInformation
      item.number = (item.genericReward && item.genericReward.number) || ''
      item.businessDescription = (item.genericReward && item.genericReward.businessDescription) || ''
      item.cpsBind = (item.genericReward && item.genericReward.cpsBind) || ''
      item.id = (item.genericReward && item.genericReward.id) || ''
      item.alreadyRefund = (item.genericReward && item.genericReward.alreadyRefund) || ''
      item.refundMoney = refundInfo.money && cashCount(refundInfo.money, true, 2)
      extendInformation.cpsRegion = extendInformation.cpsRegion || '--'
      extendInformation.user_type = extendInformation.userType && getEnumeration(extendInformation.userType, auditTypes)
      extendInformation.achieve_date = extendInformation.achieveDate && timeutils.format(extendInformation.achieveDate, 'date')
      item.contract_date = extendInformation.contractDate && timeutils.format(extendInformation.contractDate, 'date')
      extendInformation.register_date = extendInformation.registerDate && timeutils.format(extendInformation.registerDate, 'date')
      item.reward_money = (reward.money && cashCount(reward.money, true, 2)) || 0
      item.couponTotalAmount = reward.couponTotalAmount && cashCount(reward.couponTotalAmount, true, 2)
      item.created_date = (item.genericReward && item.genericReward.createdDate) && timeutils.format(item.genericReward.createdDate, 'date')
      item.reward_date = (item.genericReward && item.genericReward.rewardDate) && timeutils.format(item.genericReward.rewardDate, 'date')
      item.audit_status = (item.genericReward && item.genericReward.status) && getEnumeration(item.genericReward.status, auditStatus)
      item.audit_status = (item.genericReward && item.genericReward.businessType === 'CUSTOMER_BRING_NEW_QJK')
                ? this.rewardStatusOfQJK((item.genericReward && item.genericReward.status), customerBringNew.finalRewardCount, item.audit_status) : item.audit_status
      item.approval_date = (item.genericReward && item.genericReward.approvalDate) && timeutils.format(item.genericReward.approvalDate, 'date')
      extendInformation = datas.cpsContractData(extendInformation)
      item.oldCustomer = customerBringNew.oldCustomer || {}
      item.newCustomer = customerBringNew.newCustomer || {}
      item.oldCustomer.reward_money = (item.oldCustomer.reward && item.oldCustomer.reward.money && cashCount(item.oldCustomer.reward.money, true, 2)) || 0
      item.oldCustomer.couponTotalAmount = (item.oldCustomer.reward && item.oldCustomer.reward.couponTotalAmount) && cashCount(item.oldCustomer.reward.couponTotalAmount, true, 2)
      item.newCustomer.reward_money = (item.newCustomer.reward && item.newCustomer.reward.money && cashCount(item.newCustomer.reward.money, true, 2)) || 0
      item.newCustomer.couponTotalAmount = (item.newCustomer.reward && item.newCustomer.reward.couponTotalAmount) && cashCount(item.newCustomer.reward.couponTotalAmount, true, 2)
      item.contractInformationOfOld = item.oldCustomer.contractInformation || []
      item.contractInformationOfNew = item.newCustomer.contractInformation || []
      if (item.contractInformationOfOld.length) {
        item.contractInformationOfOld.forEach(etem => {
          etem.productInformation.forEach(atem => {
            atem.contractCode = etem.contractCode
            atem.motherName = etem.motherName
            atem.cpsRegion = etem.cpsRegion
          })
        })
      }
      if (item.contractInformationOfNew.length) {
        item.contractInformationOfNew.forEach(etem => {
          etem.productInformation.forEach(atem => {
            atem.contractCode = etem.contractCode
            atem.motherName = etem.motherName
            atem.cpsRegion = etem.cpsRegion
          })
        })
      }
    })
    return data
  },
  // 脐荐康状态显示特殊处理
  rewardStatusOfQJK (tatus, finalRewardCount, auditStatus) {
    switch (tatus) {
      case 'WAITING_FOR_APPROVAL':
        auditStatus = finalRewardCount === '第一轮' ? '待地区审核' : '待总部客服审核'
        break
      case 'SALES_COMPLETED':
        auditStatus = finalRewardCount === '第一轮' ? '待地区财务审核' : '待总部财务审核'
        break
      case 'SALES_REJECTED':
        auditStatus = finalRewardCount === '第一轮' ? '地区已驳回' : '总部客服已驳回'
        break
      case 'REJECTED':
        auditStatus = finalRewardCount === '第一轮' ? '地区财务已驳回' : '总部财务已驳回'
        break
      default:
        break
    }
    return auditStatus
  },
  // 新老用户数据层级减少

  BringNewAuditDetail (data) {
    let extendInformation = data.extendInformation || {}
    let reward = data.reward || {}
    let customerBringNew = extendInformation.customerBringNew || {}
    let oldCustomer = customerBringNew.oldCustomer || {}
    let newCustomer = customerBringNew.newCustomer || {}
    let refundInfo = data.refundInfo || {}
    // oldCustomer.contractInformation = BringNewAuditContractData(oldCustomer.contractInformation)
    extendInformation.cpsRegion = extendInformation.cpsRegion || '--'
    extendInformation = datas.cpsContractData(extendInformation)
    data.userType = extendInformation.userType && getEnumeration(extendInformation.userType, auditTypes)
    data.achieve_date = extendInformation.achieveDate && timeutils.format(extendInformation.achieveDate, 'date')
    data.contract_date = extendInformation.contractDate && timeutils.format(extendInformation.contractDate, 'date')
    data.register_date = extendInformation.registerDate && timeutils.format(extendInformation.registerDate, 'date')
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    data.reward_date = data.rewardDate && timeutils.format(data.rewardDate, 'date')
    data.CPSbindDate = timeutils.format(data.bindDate, 'date')
    data.CPSbindDate = timeutils.format(data.bindDate, 'date')
    data.reward_money = (reward.money && cashCount(reward.money, true, 2)) || 0
    data.reward_realPay = (reward.realPay && cashCount(reward.realPay, true, 2)) || 0 // 公司实付
    data.moneyRewardAmount = reward.money && cashCount(reward.money, true, 2)
    data.audit_status = data.status && getEnumeration(data.status, auditStatus)
    data.audit_status = data.businessType === 'CUSTOMER_BRING_NEW_QJK'
            ? this.rewardStatusOfQJK(data.status, customerBringNew.finalRewardCount, data.audit_status) : data.audit_status
    data.couponRewardAmount = reward.couponTotalAmount && cashCount(reward.couponTotalAmount, true, 2)
    data.refundTime = refundInfo.time && timeutils.format(refundInfo.time)
    data.refundMoney = refundInfo.money && cashCount(refundInfo.money, true, 2)
    data.reject_date = data.rejectDate && timeutils.format(data.rejectDate)
    data.approval_date = data.approvalDate && timeutils.format(data.approvalDate)
    data.sales_approval_date = data.salesApprovalDate && timeutils.format(data.salesApprovalDate)
    data.treasurer_approval_date = data.treasurerApprovalDate && timeutils.format(data.treasurerApprovalDate)
    data.selars_reject_date = data.salesRejectDate && timeutils.format(data.salesRejectDate)
    data.treasurer_reject_date = data.treasurerRejectDate && timeutils.format(data.treasurerRejectDate)
    if (data.reward && data.reward.discountCoupons && data.reward.discountCoupons.length > 0) {
      data.reward.discountCoupons.forEach(item => {
        item.discountCoupon.discount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.discount && '¥' + cashCount(item.discountCoupon.couponData.discount, true, 2)
        item.discountCoupon.thresholdOfAmount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.thresholdOfAmount && cashCount(item.discountCoupon.couponData.thresholdOfAmount, true)
      })
    }
    data.business_type = getEnumeration(data.businessType, businessTypes)
    return {
      ...data,
      oldCustomer: oldCustomer,
      newCustomer: newCustomer
    }
  },
  // 合同数据处理
  // BringNewAuditContractData (data) {
  //   data.forEach(item=>{
  //     item.forEach(etem=>{

  //     })
  //   })
  // },
  approvalByBatchBringNew (data) {
    let failedDetailList = data.failedDetailList || []
    failedDetailList.forEach(item => {
      item.user_type = item.userType && getEnumeration(item.userType, auditTypes)
      item.reward_type = item.rewardType && getEnumeration(item.rewardType, rewardTypes)
    })
    return data
  },
  getWithdrawalsList (data) {
    data.forEach(item => {
      let bankAccount = item.bankAccount || {}
      item.withdraw_date = item.date && timeutils.format(item.date, 'date')
      item.withdraw_status = item.status && getEnumeration(item.status, withdrawStatus)
      item.withdraw_amount = item.amount && cashCount(item.amount, true, 2)
      item.withdraw_actualAmount = item.actualAmount ? item.actualAmount && cashCount(item.actualAmount, true, 2) : '--'
      item.approval_date = item.approveDate && timeutils.format(item.approveDate, 'date')
      bankAccount.card_number = bankAccount.cardNumber && strReplace(bankAccount.cardNumber, 4)
      item.accountName = item.withdrawalsChannel && item.withdrawalsChannel === 'WXPAY' ? item.wxWithdrawalsAccount.userName : item.bankAccount.accountName
      item.accountType = item.withdrawalsChannel && item.withdrawalsChannel === 'WXPAY' ? item.accountName + '（微信零钱）' : item.accountName + `（银行卡 ${bankAccount.card_number.substring(bankAccount.card_number.length - 4)}）`
    })
    return data
  },
  withdrawalDetail (data) {
    let bankAccount = data.bankAccount || {}
    data.withdraw_amount = data.amount && cashCount(data.amount, true, 2)
    data.withdraw_actualAmount = data.actualAmount && cashCount(data.actualAmount, true, 2)
    data.withdraw_date = data.date && timeutils.format(data.date)
    data.withdraw_status = data.status && getEnumeration(data.status, withdrawStatus)
    bankAccount.card_number = bankAccount.cardNumber && strReplace(bankAccount.cardNumber, 4)
    bankAccount.id_card = bankAccount.idCard && strReplace(bankAccount.idCard, 4, 4)
    data.approval_date = data.approveDate && timeutils.format(data.approveDate)
    data.operator_date = data.operatorDate && timeutils.format(data.operatorDate)
    return data
  },
  customerGrantReward (data) {
    data.forEach(item => {
      let extendInformation = item.extendInformation || {}
      let reward = item.reward || {}
      extendInformation.register_date = extendInformation.registryDate && timeutils.format(extendInformation.registryDate, 'date')
      item.couponTotalAmount = reward.couponTotalAmount && cashCount(reward.couponTotalAmount, true, 2)
      item.reward_money = reward.money && cashCount(reward.money, true, 2)
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
      item.approval_date = item.approvalDate && timeutils.format(item.approvalDate, 'date')
      item.businessDepartmentName = item.businessDepartmentName || '--'
      item.audit_status = item.status && getEnumeration(item.status, manualAuditStatus)
      // item.rewardType = item.rewardType === 'MANUAL_REWARD' ? '手动发放奖励' : (item.rewardType || item.businessDescription)
      // item.rewardType = item.businessDescription || item.rewardType
    })
    return data
  },
  genericRewardDetail (data, businessTypes) {
    let extendInformation = data.extendInformation || {}
    let reward = data.reward || {}
    data.userType = extendInformation.userType && getEnumeration(extendInformation.userType, auditTypes)
    data.contract_date = extendInformation.contractDate && timeutils.format(extendInformation.contractDate, 'date')
    extendInformation.userName = extendInformation.firstName
    extendInformation.userMobile = extendInformation.mobile
    data.register_date = extendInformation.registryDate && timeutils.format(extendInformation.registryDate, 'date')
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    data.reward_money = (reward.money && cashCount(reward.money, true, 2)) || 0
    data.reward_realPay = (reward.realPay && cashCount(reward.realPay, true, 2)) || 0 // 公司实付
    data.moneyRewardAmount = reward.money && cashCount(reward.money, true, 2)
    data.audit_status = data.status && getEnumeration(data.status, manualAuditStatus)
    data.couponRewardAmount = reward.couponTotalAmount && cashCount(reward.couponTotalAmount, true, 2)
    data.reject_date = data.rejectDate && timeutils.format(data.rejectDate)
    data.approval_date = data.approvalDate && timeutils.format(data.approvalDate)

    // data.reject_date = data.rejectDate && timeutils.format(data.rejectDate)
    // data.approval_date = data.approvalDate && timeutils.format(data.approvalDate)
    data.sales_approval_date = data.salesApprovalDate && timeutils.format(data.salesApprovalDate)
    data.treasurer_approval_date = data.treasurerApprovalDate && timeutils.format(data.treasurerApprovalDate)
    data.selars_reject_date = data.salesRejectDate && timeutils.format(data.salesRejectDate)
    data.treasurer_reject_date = data.treasurerRejectDate && timeutils.format(data.treasurerRejectDate)
    if (data.reward && data.reward.discountCoupons && data.reward.discountCoupons.length > 0) {
      data.reward.discountCoupons.forEach(item => {
        item.discountCoupon.discount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.discount && '¥' + cashCount(item.discountCoupon.couponData.discount, true, 2)
        item.discountCoupon.thresholdOfAmount = item.discountCoupon && item.discountCoupon.couponData && item.discountCoupon.couponData.thresholdOfAmount && cashCount(item.discountCoupon.couponData.thresholdOfAmount, true)
      })
    }
    businessTypes.forEach(item => {
      if (item.value === data.businessType) {
        data.business_type = item.name
      }
    })
    return data
  },
  flashBorrowList (data) {
    data.forEach(item => {
      item.apply_date = item.applyDate && timeutils.format(item.applyDate)
      item.borrowStatus = item.status && getEnumeration(item.status, flashBorrowStatus)
      item.cash_back_amount = item.cashBackAmount && cashCount(item.cashBackAmount, true, 2)
    })
    return data
  },
  flashBorrowDetail (data) {
    data.apply_date = data.applyDate && timeutils.format(data.applyDate)
    data.borrowStatus = data.status && getEnumeration(data.status, flashBorrowStatus)
    data.cash_back_amount = data.cashBackAmount && cashCount(data.cashBackAmount, true, 2)
    return data
  },
  getAllAuditList (data) {
    data.forEach(item => {
      let extendInformation = item.extendInformation || {}
      let doctorInfo = extendInformation.doctorInfo || {}
      let motherInfo = extendInformation.motherInfo || {}
      let hospitals = doctorInfo.hospitals || []
      let addressDetails = doctorInfo.addressDetails || {}
      let hospitalsName = ''
      hospitals.forEach(item => {
        if (item.name !== '其他') {
          hospitalsName = hospitalsName.length === 0 ? item.name : ',' + item.name
        }
      })
      item.motherName = motherInfo.motherName || '--'
      item.expectedDateOfConfinement = (motherInfo.expectedDateOfConfinement && timeutils.format(motherInfo.expectedDateOfConfinement)) || '--'
      item.hospitalsName = hospitalsName || '--'
      item.extendInformation_addressDetails = (addressDetails.provinceName || '') + (addressDetails.cityName || '') + (addressDetails.districtName || '')
      item.triggerRewardUser_name = item.triggerRewardUser && item.triggerRewardUser.name
      item.triggerRewardUser_mobile = item.triggerRewardUser && item.triggerRewardUser.mobile
      item.isSalesMan = item.salesMan ? '是' : '否'
      item.isCpsBind = item.cpsBind ? '是' : '否'
      item.reward_money = item.reward && item.reward.money && cashCount(item.reward.money, true, 2)
      item.reward_coupon_total_amount = item.reward && item.reward.couponTotalAmount && cashCount(item.reward.couponTotalAmount, true, 2)
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
      item.audit_status = item.status && getEnumeration(item.status, manualAuditStatus)
    })
    return data
  },
  getUserBalance (data) {
    data.balance_show = data.balance && cashCount(data.balance, true)
    return data
  },
  getBalanceList (data) {
    data.forEach(item => {
      item.changeOperationType = item.operationType === 'INCREASE' ? '增加' : '减少'
      item.balance_show = item.operationType === 'INCREASE' ? cashCount(item.amount, true) : ('-' + cashCount(item.amount, true))
      item.operate_time = item.operateTime ? timeutils.format(item.operateTime, 'date') : '--'
      item.content_show = item.content
      item.operatorName = item.operatorName || '--'
      let department = {
        id: item.departmentId,
        name: item.departmentName
      }
      item.department = JSON.stringify(department)
    })
    return data
  },
  getBalanceDetail (data) {
    data.changeOperationType = data.operationType === 'INCREASE' ? '增加' : '减少'
    data.balance_show = data.operationType === 'INCREASE' ? cashCount(data.amount, true) : ('-' + cashCount(data.amount, true))
    data.operate_time = data.operateTime ? timeutils.format(data.operateTime, 'date') : '--'
    data.content_show = data.content
    let department = {
      id: data.departmentId,
      name: data.departmentName
    }
    data.department = JSON.stringify(department)
    return data
  },
  bankCardBalance (data) {
    data.balance_card_show = data.bankCardBalanceFen && cashCount(data.bankCardBalanceFen, true)
    data.balance_wx_show = data.wxpayBalanceFen && cashCount(data.wxpayBalanceFen, true)
    let wxpayBalanceFen = typeof (data.wxpayBalanceFen) === 'number' ? data.wxpayBalanceFen : Number(data.wxpayBalanceFen)
    let bankCardBalanceFen = typeof (data.bankCardBalanceFen) === 'number' ? data.bankCardBalanceFen : Number(data.bankCardBalanceFen)
    data.balanceFen = (wxpayBalanceFen && bankCardBalanceFen) ? (bankCardBalanceFen + wxpayBalanceFen) : (wxpayBalanceFen || bankCardBalanceFen)
    data.balance_show = data.balanceFen && cashCount(data.balanceFen, true)
    data.bankCardBalance = data.bankCardBalanceFen && cashCount(data.bankCardBalanceFen, true)
    return data
  },
  // 退款方式获取
  refundMethod (data) {
    data.forEach(item => {
      item.reason = item.extensionInfo && item.extensionInfo.reason
      item.money = item.extensionInfo && item.extensionInfo.money && cashCount(item.extensionInfo.money, true, 2)
    })
    return data
  },
  // 处理订金结算的数据
  getDepositSettlementList (data) {
    data.forEach(item => {
      let goodsFormData = (item.placementDetails && item.placementDetails.goodsFormData) || {}
      let paymentDetails = item.paymentDetails || {}
      let placeUserRoleInformation = item.placeUserRoleInformation || {}
      item.userName = placeUserRoleInformation.fullName || '--'
      item.userMobile = placeUserRoleInformation.mobile || '--'
      let rewardData = {}
      item.orderNumber = item.orderNumber || '--'
      item.mobile = item.mobile || '--'
      item.organizationName = item.organizationName || '--'
      item.orderStatus = (item.orderStatus && getEnumeration(item.orderStatus, newOrderStatus)) || '--'
      // if (item.refundmentDetails) {
      //   item.orderStatus = (item.refundmentDetails.status && getEnumeration(item.refundmentDetails.status, orderRefundStatus)) || '--'
      // }
      item.rewardData.forEach(sItem => {
        if (sItem.extendInformation && sItem.extendInformation.rewardCount === 1) {
          rewardData = sItem
        }
      })
      let refundmentDetails = item.refundmentDetails || {}
      let goods = item.goods && item.goods[0]
      item.depositAuditOrderingType = (goods.type && goodsTypes[goods.type]) || goods.typeName
      item.goodsName = (item.goods[0] && item.goods[0].name) || '--'
      item.certificateNumber = (goodsFormData.data && goodsFormData.data.certificateNumber) || '--'
      item.motherName = (goodsFormData.data && goodsFormData.data.name) || '--'
      item.motherPhone = (goodsFormData.data && goodsFormData.data.phone) || '--'
      item.address = (goodsFormData.data && goodsFormData.data.address && goodsFormData.data.address.map(item => item.text).join('/')) || '--'
      item.payTime = paymentDetails.time ? timeutils.format(paymentDetails.time, 'date') : '--'
      item.paymentChannel = paymentDetails.channel && getEnumeration(paymentDetails.channel, channelOptions)
      item.amount = (item.MallOrderRefundmentDetails && cashCount(item.MallOrderRefundmentDetails.balance, true, 2)) || cashCount(item.totalAmount, true, 2)
      if (refundmentDetails && refundmentDetails.status === 'REFUND_COMPLETED') {
        item.amount = cashCount(refundmentDetails.balance, true, 2)
      }
      item.rewardStatus = (rewardData && rewardData.status && getEnumeration(rewardData.status, showRewardStatus)) || '无奖励'
      item.hasRecord = (item.orderAuditStatus && getEnumeration(item.orderAuditStatus, rewardedStatus)) || '未入库'
      item.hasOperation = (item.rewardStatus === '已审核' && item.orderAuditStatus !== 'RECORDED')
    })
    return data
  },
  getPointsRewardList (data) {
    data.forEach(item => {
      let grantUser = item.grantUser || {}
      grantUser.register_date = grantUser.registryDate && timeutils.format(grantUser.registryDate, 'date')
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
      item.approval_date = item.auditTime && timeutils.format(item.auditTime, 'date')
      item.reject_date = item.rejectTime && timeutils.format(item.rejectTime, 'date')
      item.businessDepartmentName = item.businessDepartmentName || '--'
      item.audit_status = item.status && getEnumeration(item.status, integralAuditStatus)
    })
    return data
  },
  getPointsRewardsDetail (item) {
    let grantUser = item.grantUser || {}
    grantUser.register_date = grantUser.registryDate && timeutils.format(grantUser.registryDate, 'date')
    item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
    item.approval_date = item.auditTime && timeutils.format(item.auditTime, 'date')
    item.reject_date = item.rejectTime && timeutils.format(item.rejectTime, 'date')
    item.businessDepartmentName = item.businessDepartmentName || '--'
    item.audit_status = item.status && getEnumeration(item.status, integralAuditStatus)
    return item
  },
  getScanPaymentList (data) {
    data.forEach(item => {
      item.channel = item.channel && getEnumeration(item.channel, payOptions)
      item.status = item.status && getEnumeration(item.status, payStaus)
      item.last_modified_date = item.lastModifiedDate && timeutils.format(item.lastModifiedDate, 'default')
      item.pay_starting_time = item.payStartingTime && timeutils.format(item.payStartingTime, 'default')
      item.amount = item.amount && cashCount(item.amount, true, 2)
    })
    return data
  }
}
